import React from 'react';
import { Button, Container, Typography, Box, Stack, Avatar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DamsAppAsset } from '../assets/registry';

const UnauthorizedAccessPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
      <Box>
      <Stack alignItems={'center'} justifyContent={'center'} spacing={5}>
      <Avatar src={DamsAppAsset.icons.warning} sx={{width:50,height:50}}/>
      <Typography variant="h3" color="error" gutterBottom>
           Access Denied
        </Typography>
      </Stack>

        <Typography variant="h6" color="textSecondary" sx={{ mb: 4 }}>
          You don’t have permission to access this page.
          <br />
          Please contact your administrator for any inquiries.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/')}
        >
          Go Back
        </Button>
      </Box>
    </Container>
  );
};

export default UnauthorizedAccessPage;
